'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionNotes', ['$scope', function ($scope) {
        $scope.resetInspection();
        $scope.columns = [
            {
                label: 'Note',
                field: 'note_display',
                link: {
                    state: 'internal.inspecting.inspection.note',
                    params: [
                        {
                            name: 'inspectionNoteID',
                            field: 'id'
                        },
                        {
                            name: 'inspection_note',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];
    }])
;